import { render, staticRenderFns } from "./circular-percentage-chart.html?vue&type=template&id=d5ea0638&scoped=true&"
import script from "./circular-percentage-chart.ts?vue&type=script&lang=js&"
export * from "./circular-percentage-chart.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ea0638",
  null
  
)

export default component.exports